// removed by extract-text-webpack-plugin
module.exports = {"wrap-news-letter-register":"wrap-news-letter-register","title-black":"title-black","news-letter-description":"news-letter-description","label-for-title":"label-for-title","has-value":"has-value","wrap-input":"wrap-input","news-letter-input":"news-letter-input","news-letter-button":"news-letter-button","wrap-title":"wrap-title","wrap-img":"wrap-img","news-letter-img":"news-letter-img"};


//////////////////
// WEBPACK FOOTER
// ./components/home/sub-view/_NewsLetterRegister.scss
// module id = ./components/home/sub-view/_NewsLetterRegister.scss
// module chunks = 0